import React, { useState, useRef, useEffect } from 'react';
import { FlexBox, InlineItemWithMargin } from '../Components';
import { getTranslateByScope } from '../i18n';
import AppContext from '../AppContext';
import { genres } from '../constants';
import { TopMenuModal } from './TopMenuModal';
import { Genre } from './Genre';

export const translate = getTranslateByScope('app.genres');

// Small delay so moving the mouse from the genres down to the menu doesn't close it
const CLOSE_DELAY = 200;

export const GenrePicker = ({ anchorRef }) => {
  const [isOpen, setIsOpen] = useState(false);
  // The menu shows the clusters of the hovered genre
  const [menuGenre, setMenuGenre] = useState(null);
  const triggerRef = useRef(null);
  const closeTimeout = useRef(null);

  const cancelClose = () => clearTimeout(closeTimeout.current);

  const open = (genre) => {
    cancelClose();
    setMenuGenre(genre);
    setIsOpen(true);
  };

  const close = () => {
    cancelClose();
    setIsOpen(false);
  };

  const scheduleClose = () => {
    cancelClose();
    closeTimeout.current = setTimeout(() => setIsOpen(false), CLOSE_DELAY);
  };

  useEffect(() => cancelClose, []);

  return (
    <AppContext.Consumer>
      {({ actions }) => (
          <>
            <TopMenuModal
              isOpen={isOpen}
              genre={menuGenre}
              anchorRef={anchorRef || triggerRef}
              triggerRef={triggerRef}
              onClose={close}
              onMouseEnter={cancelClose}
              onMouseLeave={scheduleClose}
            />
            <div ref={triggerRef} onMouseEnter={cancelClose} onMouseLeave={scheduleClose}>
              <FlexBox>
                <Genre
                  value={genres.men}
                  actions={actions}
                  isActive={isOpen ? menuGenre === genres.men : undefined}
                  onMouseEnter={() => open(genres.men)}
                />
                <InlineItemWithMargin>
                  <Genre
                    value={genres.woman}
                    actions={actions}
                    isActive={isOpen ? menuGenre === genres.woman : undefined}
                    onMouseEnter={() => open(genres.woman)}
                  />
                </InlineItemWithMargin>
              </FlexBox>
            </div>
          </>
      )}
    </AppContext.Consumer>
  );
};

export default GenrePicker;
